<template>
  <!-- banner topo -->
  <div v-if="bannerTopo != ''" class="bannerTopo-area">
    <div class="bannerTopo-height d-flex align-items-center">

      <div class="bannerTopo-img">
        <img :src="$imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem" class="bannerTopo-bg-fill" alt="">
      </div>

      <div class="bannerTopo-overlay"></div>

      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-8 col-lg-10">
            <div class="bannerTopo-caption text-center">
              <h2>{{ bannerTopo[0].itiNome }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--=== produto ========================-->
  <div class="about-area section-bg">
    <div class="container">

      <div v-if="listaServicos != ''" class="row align-items-center">
        <div class="col-xl-6 col-lg-6 col-md-12">
          <div class="about-img produto">
            <img :src="$imgURL + listaServicos.insInstitucionalImagens[0].itgUrlImagem" 
               :alt="listaServicos.itiNome"
               class="w-100 shadow-sm">
          </div>
        </div>
        <div class="col-xl-5 col-lg-6 col-md-12 offset-xl-1">
          <div class="about-cap-right">
            <div class="section-tittle">
              <h2>{{ listaServicos.itiNome }}</h2>
              <p v-html="listaServicos.itiResumo1"></p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="listaServicos != ''" class="row align-items-center">
        <div class="col-xl-5 col-lg-6 col-md-12  order-2 order-lg-1">
          <div class="about-cap-right">
            <div class="section-tittle pt-4 pt-lg-0">
              <h2>{{ listaServicos.itiReferencia }}</h2>
              <p v-html="listaServicos.itiResumo2"></p>
            </div>
          </div>
        </div>

        <div class="col-xl-6 col-lg-6  offset-xl-1 col-md-12 order-1 order-lg-2">
          <div class="about-img produto">
            <img :src="$imgURL + listaServicos.insInstitucionalImagens[1].itgUrlImagem" 
               alt="" 
               class="w-100 shadow-sm">
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- planos ================================-->
  <section v-if="listaPlanos.length > 0" class="planos-area section-padding">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-6 col-lg-7 col-md-10">
          <div class="section-tittle text-center mb-60">
            <h2>Nossos Planos</h2>
          </div>
        </div>
      </div>
      <div class="row">

        <div v-for="planos in listaPlanos[0]?.insInstitucionalGrids" :key="planos.igsId || planos.igsOrdem" class="col-xl-3 col-lg-3 col-md-6 mb-20">
          <div class="single-planos mb-30 text-center">
            <div class="planos-header">
              <h3>{{ planos.igsNome }}</h3>
            </div>
            <div class="planos-list">
              <ul>
                <li v-html="planos.igsResumo"></li>
              </ul>
            </div>
            <div class="planos-btn">
              <router-link :to="'/contato'" class="btn_planos">ASSINE JÁ</router-link>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!--=============== call to action ====================-->
  <PageCallAction></PageCallAction>

</template>

<script>
import { useHead } from '@vueuse/head';
import axios from 'axios';
import { useRoute } from 'vue-router';
import PageCallAction from '@/components/PageCallAction.vue';

export default {
  name: 'ProdutosDetalheView',

  components: {
    PageCallAction,
  },

  setup() {
    const route = useRoute();
    const id = route.params.id;
    const nome = route.params.nome;
    return {
      id,
      nome
    };
  },

  data: () => ({
    listaServicos: [],
    bannerTopo: [],
    listaPlanos: [],
  }),

  methods: {
    toggleItem(id) {
      // Se clicar no que já está aberto, ele fecha. Se não, abre o novo.
      this.itemAberto = this.itemAberto === id ? null : id;
    },

    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

    carregaMetas(texto, titulo) {
      useHead({
        title: 'Lukon :: ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Avance Digital" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },
  },

  created() {
    this.carregaMetas("---");

    // BANNER TOPO
    axios.get('/Process/InsInstitucional/institucional/59/topoprodutos/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        this.carregaMetas(this.removerTagsHTML, this.bannerTopo[0].itiNome);
        //console.log('bannerTopo')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });

    // LISTA DE SERVIÇOS
    axios.get('/Process/InsInstitucional/GetById/' + this.id)
      .then(response => {
        this.listaServicos = response.data;
        //console.log('listaServicos')
        //console.log(this.listaServicos)
      })
      .catch(error => {
        console.error(error);
      });

    // PLANOS
    axios.get('/Process/InsInstitucional/institucional/46/listadeprodutos/0/x')
      .then(response => {
        // 1. Filtramos apenas o que é visível
        const dadosFiltrados = response.data.filter(x => x.itiVisivel);

        // 2. Para cada item da lista, vamos ordenar o array de planos (insInstitucionalGrids)
        this.listaPlanos = dadosFiltrados.map(item => {
          if (item.insInstitucionalGrids) {
            item.insInstitucionalGrids.sort((a, b) => {
              return (parseInt(a.igsOrdem) || 0) - (parseInt(b.igsOrdem) || 0);
            });
          }
          return item;
        });

        //console.log('Lista ordenada por igsOrdem:', this.listaPlanos);
      })
      .catch(error => console.error(error));



  },
}
</script>

<style scoped></style>